import { Component, Input } from '@angular/core';
import { GasOverMudIPP, GasInfluxBase, InternalPressureProfileType } from '../../../models/internal-pressure-profile.model';
import { createForm, FormType, subformComponentProviders } from 'ngx-sub-form';
import { UserUnitsModel } from 'src/app/core/components/user-units/user-units.model';
import { UntypedFormControl, Validators } from '@angular/forms';
import { WellComponent } from 'src/app/wellbore-inputs/components/well-configuration/models/well-component';
import { PoreFrac } from 'src/app/perivis/models/poreFrac.model';

interface GasOverMudForm {
  type: InternalPressureProfileType.GASOVERMUD;
  gasInfluxBase: GasInfluxBase;
}

@Component({
  selector: 'app-gas-over-mud',
  template: `
    <form [formGroup]="form.formGroup" class="flex flex-col">
      <app-gas-influx-base
        [formControlName]="form.formControlNames.gasInfluxBase"
        [userUnits]="userUnits"
        [currentString]="currentString"
        [fractureDepthDefault]="fractureDepthDefault"
        [influxDepthRange]="influxDepthRange"
        [nextStringMudWeight]="nextStringMudWeight"
        [tubulars]="tubulars"
        [fracPressures]="fracPressures"
        [porePressures]="porePressures"
        [isGasOverMud]="true"
        [wellheadDepth]="wellheadDepth"
      />
    </form>
  `,
  providers: subformComponentProviders(GasOverMudComponent),
  standalone: false
})
export class GasOverMudComponent {
  @Input() currentString: any;
  @Input() userUnits: UserUnitsModel;
  @Input() influxDepthRange: { min: number, max: number };
  @Input() fractureDepthDefault: number;
  @Input() nextStringMudWeight: number;
  @Input() tubulars: WellComponent[];
  @Input() fracPressures: PoreFrac[];
  @Input() porePressures: PoreFrac[];
  @Input() wellheadDepth: number;

  public form = createForm<GasOverMudIPP, GasOverMudForm>(this, {
    formType: FormType.SUB,
    formControls: {
      type: new UntypedFormControl(InternalPressureProfileType.GASOVERMUD),
      gasInfluxBase: new UntypedFormControl(null, Validators.required)
      
    },
    toFormGroup: (obj: GasOverMudIPP | null): GasOverMudForm | null => {
      return {
        type: InternalPressureProfileType.GASOVERMUD,
        gasInfluxBase: obj
      };
    },
    fromFormGroup: (formValue: GasOverMudForm): GasOverMudIPP | null => {
      return {
        type: InternalPressureProfileType.GASOVERMUD,
        ...formValue.gasInfluxBase
      };
    }
  });
}
